import { default as indexO19aScTM0SMeta } from "/opt/build/repo/pages/be-suntimers/index.vue?macro=true";
import { default as indexx3sznPgcaVMeta } from "/opt/build/repo/pages/blog/[slug]/index.vue?macro=true";
import { default as indexmFsYN4t0XfMeta } from "/opt/build/repo/pages/blog/index.vue?macro=true";
import { default as index3pMDvcbybxMeta } from "/opt/build/repo/pages/chat-lgbt/index.vue?macro=true";
import { default as indexQ7EC96mn4oMeta } from "/opt/build/repo/pages/cookie-policy/index.vue?macro=true";
import { default as indexrAuuacHkk9Meta } from "/opt/build/repo/pages/fight-gravity-event/index.vue?macro=true";
import { default as indexuJXuDt3rtiMeta } from "/opt/build/repo/pages/fight-gravity/index.vue?macro=true";
import { default as form_45submission_45failureddjxJla3GJMeta } from "/opt/build/repo/pages/form-submission-failure.vue?macro=true";
import { default as form_45submission_45successk0ay3CQ3szMeta } from "/opt/build/repo/pages/form-submission-success.vue?macro=true";
import { default as indexpzMRyvQTTbMeta } from "/opt/build/repo/pages/get-in-touch/index.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as indexzGeY41wuBWMeta } from "/opt/build/repo/pages/iso-certified/index.vue?macro=true";
import { default as indexWgEuXv9ZaTMeta } from "/opt/build/repo/pages/podcast-grandi-imprese/index.vue?macro=true";
import { default as index9d90rQCWYDMeta } from "/opt/build/repo/pages/privacy-policy/index.vue?macro=true";
import { default as indexBmiOq17LApMeta } from "/opt/build/repo/pages/projects/[slug]/index.vue?macro=true";
import { default as index6xlv7fvD7GMeta } from "/opt/build/repo/pages/what/index.vue?macro=true";
import { default as indexBwPhN8nMBBMeta } from "/opt/build/repo/pages/whistleblowing/index.vue?macro=true";
import { default as indexFtj1cO7jywMeta } from "/opt/build/repo/pages/who/index.vue?macro=true";
import { default as indexhtcyXUnZLsMeta } from "/opt/build/repo/pages/why/index.vue?macro=true";
import { default as indexHlIkK91IhRMeta } from "/opt/build/repo/pages/wonder-academy/index.vue?macro=true";
import { default as component_45stubj2xBVmyCkgMeta } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.5.1_@types+node@20.17.41_db0@0.3.2_eslint@8.57.1_ioredis@_7c4204005e5bfe3774832cebe828f4b2/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubj2xBVmyCkg } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.5.1_@types+node@20.17.41_db0@0.3.2_eslint@8.57.1_ioredis@_7c4204005e5bfe3774832cebe828f4b2/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "be-suntimers___it",
    path: "/be-suntimers",
    meta: indexO19aScTM0SMeta || {},
    component: () => import("/opt/build/repo/pages/be-suntimers/index.vue").then(m => m.default || m)
  },
  {
    name: "be-suntimers___en",
    path: "/en/be-suntimers",
    meta: indexO19aScTM0SMeta || {},
    component: () => import("/opt/build/repo/pages/be-suntimers/index.vue").then(m => m.default || m)
  },
  {
    name: "blog-slug___it",
    path: "/blog/:slug()",
    meta: indexx3sznPgcaVMeta || {},
    component: () => import("/opt/build/repo/pages/blog/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "blog-slug___en",
    path: "/en/blog/:slug()",
    meta: indexx3sznPgcaVMeta || {},
    component: () => import("/opt/build/repo/pages/blog/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___it",
    path: "/blog",
    meta: indexmFsYN4t0XfMeta || {},
    component: () => import("/opt/build/repo/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___en",
    path: "/en/blog",
    meta: indexmFsYN4t0XfMeta || {},
    component: () => import("/opt/build/repo/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "chat-lgbt___it",
    path: "/chat-lgbt",
    meta: index3pMDvcbybxMeta || {},
    component: () => import("/opt/build/repo/pages/chat-lgbt/index.vue").then(m => m.default || m)
  },
  {
    name: "chat-lgbt___en",
    path: "/en/chat-lgbt",
    meta: index3pMDvcbybxMeta || {},
    component: () => import("/opt/build/repo/pages/chat-lgbt/index.vue").then(m => m.default || m)
  },
  {
    name: "cookie-policy___it",
    path: "/cookie-policy",
    meta: indexQ7EC96mn4oMeta || {},
    component: () => import("/opt/build/repo/pages/cookie-policy/index.vue").then(m => m.default || m)
  },
  {
    name: "cookie-policy___en",
    path: "/en/cookie-policy",
    meta: indexQ7EC96mn4oMeta || {},
    component: () => import("/opt/build/repo/pages/cookie-policy/index.vue").then(m => m.default || m)
  },
  {
    name: "fight-gravity-event___it",
    path: "/fight-gravity-event",
    meta: indexrAuuacHkk9Meta || {},
    component: () => import("/opt/build/repo/pages/fight-gravity-event/index.vue").then(m => m.default || m)
  },
  {
    name: "fight-gravity-event___en",
    path: "/en/fight-gravity-event",
    meta: indexrAuuacHkk9Meta || {},
    component: () => import("/opt/build/repo/pages/fight-gravity-event/index.vue").then(m => m.default || m)
  },
  {
    name: "fight-gravity___it",
    path: "/fight-gravity",
    meta: indexuJXuDt3rtiMeta || {},
    component: () => import("/opt/build/repo/pages/fight-gravity/index.vue").then(m => m.default || m)
  },
  {
    name: "fight-gravity___en",
    path: "/en/fight-gravity",
    meta: indexuJXuDt3rtiMeta || {},
    component: () => import("/opt/build/repo/pages/fight-gravity/index.vue").then(m => m.default || m)
  },
  {
    name: "form-submission-failure___it",
    path: "/richiesta-non-inviata",
    meta: form_45submission_45failureddjxJla3GJMeta || {},
    component: () => import("/opt/build/repo/pages/form-submission-failure.vue").then(m => m.default || m)
  },
  {
    name: "form-submission-failure___en",
    path: "/en/request-not-sent",
    meta: form_45submission_45failureddjxJla3GJMeta || {},
    component: () => import("/opt/build/repo/pages/form-submission-failure.vue").then(m => m.default || m)
  },
  {
    name: "form-submission-success___it",
    path: "/richiesta-inviata",
    meta: form_45submission_45successk0ay3CQ3szMeta || {},
    component: () => import("/opt/build/repo/pages/form-submission-success.vue").then(m => m.default || m)
  },
  {
    name: "form-submission-success___en",
    path: "/en/request-sent",
    meta: form_45submission_45successk0ay3CQ3szMeta || {},
    component: () => import("/opt/build/repo/pages/form-submission-success.vue").then(m => m.default || m)
  },
  {
    name: "get-in-touch___it",
    path: "/contatti",
    meta: indexpzMRyvQTTbMeta || {},
    component: () => import("/opt/build/repo/pages/get-in-touch/index.vue").then(m => m.default || m)
  },
  {
    name: "get-in-touch___en",
    path: "/en/get-in-touch",
    meta: indexpzMRyvQTTbMeta || {},
    component: () => import("/opt/build/repo/pages/get-in-touch/index.vue").then(m => m.default || m)
  },
  {
    name: "index___it",
    path: "/",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "iso-certified___it",
    path: "/iso-certified",
    meta: indexzGeY41wuBWMeta || {},
    component: () => import("/opt/build/repo/pages/iso-certified/index.vue").then(m => m.default || m)
  },
  {
    name: "iso-certified___en",
    path: "/en/iso-certified",
    meta: indexzGeY41wuBWMeta || {},
    component: () => import("/opt/build/repo/pages/iso-certified/index.vue").then(m => m.default || m)
  },
  {
    name: "podcast-grandi-imprese___it",
    path: "/podcast-grandi-imprese",
    meta: indexWgEuXv9ZaTMeta || {},
    component: () => import("/opt/build/repo/pages/podcast-grandi-imprese/index.vue").then(m => m.default || m)
  },
  {
    name: "podcast-grandi-imprese___en",
    path: "/en/podcast-grandi-imprese",
    meta: indexWgEuXv9ZaTMeta || {},
    component: () => import("/opt/build/repo/pages/podcast-grandi-imprese/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy___it",
    path: "/privacy-policy",
    meta: index9d90rQCWYDMeta || {},
    component: () => import("/opt/build/repo/pages/privacy-policy/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    meta: index9d90rQCWYDMeta || {},
    component: () => import("/opt/build/repo/pages/privacy-policy/index.vue").then(m => m.default || m)
  },
  {
    name: "projects-slug___it",
    path: "/progetti/:slug()",
    meta: indexBmiOq17LApMeta || {},
    component: () => import("/opt/build/repo/pages/projects/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "projects-slug___en",
    path: "/en/projects/:slug()",
    meta: indexBmiOq17LApMeta || {},
    component: () => import("/opt/build/repo/pages/projects/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "what___it",
    path: "/what",
    meta: index6xlv7fvD7GMeta || {},
    component: () => import("/opt/build/repo/pages/what/index.vue").then(m => m.default || m)
  },
  {
    name: "what___en",
    path: "/en/what",
    meta: index6xlv7fvD7GMeta || {},
    component: () => import("/opt/build/repo/pages/what/index.vue").then(m => m.default || m)
  },
  {
    name: "whistleblowing___it",
    path: "/whistleblowing",
    meta: indexBwPhN8nMBBMeta || {},
    component: () => import("/opt/build/repo/pages/whistleblowing/index.vue").then(m => m.default || m)
  },
  {
    name: "whistleblowing___en",
    path: "/en/whistleblowing",
    meta: indexBwPhN8nMBBMeta || {},
    component: () => import("/opt/build/repo/pages/whistleblowing/index.vue").then(m => m.default || m)
  },
  {
    name: "who___it",
    path: "/who",
    meta: indexFtj1cO7jywMeta || {},
    component: () => import("/opt/build/repo/pages/who/index.vue").then(m => m.default || m)
  },
  {
    name: "who___en",
    path: "/en/who",
    meta: indexFtj1cO7jywMeta || {},
    component: () => import("/opt/build/repo/pages/who/index.vue").then(m => m.default || m)
  },
  {
    name: "why___it",
    path: "/why",
    meta: indexhtcyXUnZLsMeta || {},
    component: () => import("/opt/build/repo/pages/why/index.vue").then(m => m.default || m)
  },
  {
    name: "why___en",
    path: "/en/why",
    meta: indexhtcyXUnZLsMeta || {},
    component: () => import("/opt/build/repo/pages/why/index.vue").then(m => m.default || m)
  },
  {
    name: "wonder-academy___it",
    path: "/wonder-academy",
    meta: indexHlIkK91IhRMeta || {},
    component: () => import("/opt/build/repo/pages/wonder-academy/index.vue").then(m => m.default || m)
  },
  {
    name: "wonder-academy___en",
    path: "/en/wonder-academy",
    meta: indexHlIkK91IhRMeta || {},
    component: () => import("/opt/build/repo/pages/wonder-academy/index.vue").then(m => m.default || m)
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/it",
    component: component_45stubj2xBVmyCkg
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/it/progetti",
    component: component_45stubj2xBVmyCkg
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/it/:pathMatch(.*)",
    component: component_45stubj2xBVmyCkg
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/projects",
    component: component_45stubj2xBVmyCkg
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/projects/:pathMatch(.*)",
    component: component_45stubj2xBVmyCkg
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/get-in-touch",
    component: component_45stubj2xBVmyCkg
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/search",
    component: component_45stubj2xBVmyCkg
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/en/search",
    component: component_45stubj2xBVmyCkg
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/chatlgbt",
    component: component_45stubj2xBVmyCkg
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/it/chatlgbt",
    component: component_45stubj2xBVmyCkg
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/ChatLGBT",
    component: component_45stubj2xBVmyCkg
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/it/ChatLGBT",
    component: component_45stubj2xBVmyCkg
  },
  {
    name: component_45stubj2xBVmyCkgMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubj2xBVmyCkg
  }
]